import React from "react";
import { js_utils } from "./frfr-js-utils";


// const frfr_lib_changes_id = '/FRFR/frfr-react69-utils.js/changes_id2026-03-31r1/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-react-utils
Version ID: 1a 2026-03-31r1
by 
// Please describe here if you customized this file
*/

/*

*/

/*
also:
React69Utils.js
*/

export const react_utils = {};


//
react_utils.fix_attr = (str) => {
  let attr = null;
  if (js_utils.is_number_or_string_not_empty(str)) {
    attr = str;
  }
  return attr;
};


//
react_utils.is_renderable = (content) => {
  return (
    typeof content === 'string' ||
    typeof content === 'number' ||
    React.isValidElement(content) ||
    Array.isArray(content) ||
    content === null ||
    content === undefined
  );
};

